import {CommonModule, DatePipe, TitleCasePipe} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {routing} from '../../app.routing';
import {CustomerOverviewComponent} from './customer-overview.component';
import {CustomerOverViewService} from './customer-overview.service';
import {
  CustomerDuplicateMessageComponent,
} from '~shared/components/customer-duplicate-message/customer-duplicate-message.component';
import {ModalModule} from '~shared/components/elements/modal.module';
import {WorkspaceFormModule} from '~shared/components/workspace-form/workspace-form.module';
import {TooltipModule} from '~shared/components/tooltip/tooltip.module';
import {PipesModule} from '~shared/pipes/pipes.module';
import {DirectivesModule} from '~shared/directives/directives.module';
import {TablesModule} from '~shared/components/tables/tables.module';
import {FormValidationModule} from '~core/components/form-validation/form-validation.module';
import {FormFieldsModule} from '~shared/components/form-fields/form-fields.module';
import {CustomerAccessEmailComponent} from '~shared/components/customer-access-email/customer-access-email.component';
import {ButtonsModule} from '~shared/components/buttons/buttons.module';
import {ContactManagementEditComponent} from './components/forms/contact-management-edit/contact-management-edit.component';
import {ContactManagementListComponent} from './components/info-tiles/contact-management-list/contact-management-list.component';
import {ContactManagementPageComponent} from "~features/customer-overview/pages/contact-management-page/contact-management-page.component";
import {ActivityHistoryComponent} from "~features/customer-overview/components/info-tiles/activity-history/activity-history.component";
import {AttributesComponent} from "~features/customer-overview/components/forms/attributes/attributes.component";
import {BankDataComponent} from "~features/customer-overview/components/forms/bank-data/bank-data.component";
import {BankDataEditComponent} from "~features/customer-overview/components/forms/bank-data-edit/bank-data-edit.component";
import {BankDataListComponent} from "~features/customer-overview/components/info-tiles/bank-data-list/bank-data-list.component";
import {ContactManagementComponent} from "~features/customer-overview/components/forms/contact-management/contact-management.component";
import {AddressComponent} from "~features/customer-overview/components/forms/address/address.component";
import {AddressEditComponent} from "~features/customer-overview/components/forms/address-edit/address-edit.component";
import {AddressListComponent} from "~features/customer-overview/components/info-tiles/address-list/address-list.component";
import {CustomerInvoicesListComponent} from "~features/customer-overview/components/ticketing/customer-invoices-list/customer-invoices-list.component";
import {MerchandisingListComponent} from "~features/customer-overview/components/info-tiles/merchandising-list/merchandising-list.component";
import {CampaignActivityComponent} from "~features/customer-overview/components/info-tiles/campaign-activity/campaign-activity.component";
import {CrmMembershipComponent} from "~features/customer-overview/components/forms/membership/crm-membership/crm-membership.component";
import {CrmMembershipEditComponent} from "~features/customer-overview/components/forms/membership/crm-membership-edit/crm-membership-edit.component";
import {CrmMembershipListComponent} from "~features/customer-overview/components/info-tiles/membership-list/crm-membership/crm-membership-list.component";
import {
  CampaiMembershipListComponent
} from "~features/customer-overview/components/info-tiles/membership-list/campai-membership/campai-membership-list.component";
import {MerchandisingPageComponent} from "~features/customer-overview/pages/merchandising-page/merchandising-page.component";
import {CampaignActivityPageComponent} from "~features/customer-overview/pages/campaign-activity-page/campaign-activity-page.component";
import {CustomerDataComponent} from "~features/customer-overview/components/forms/customer-data/customer-data.component";
import {CustomerDataInfoComponent} from "~features/customer-overview/components/info-tiles/customer-data-info/customer-data-info.component";
import {CommunicationDataComponent} from "~features/customer-overview/components/forms/communication-data/communication-data.component";
import {CommunicationDataInfoComponent} from "~features/customer-overview/components/info-tiles/communication-data-info/communication-data-info.component";
import {AttributesInfoComponent} from "~features/customer-overview/components/info-tiles/attributes-info/attributes-info.component";
import {CustomerInvoicesComponent} from "~features/customer-overview/components/ticketing/customer-invoices/customer-invoices.component";
import {
  CustomerReservationsListComponent
} from "~features/customer-overview/components/ticketing/customer-reservations-list/customer-reservations-list.component";
import {
  CustomerCancellationsListComponent
} from "~features/customer-overview/components/ticketing/customer-cancellations-list/customer-cancellations-list.component";
import {TicketingComponent} from "~features/customer-overview/components/ticketing/ticketing.component";
import {TicketingPageComponent} from "~features/customer-overview/pages/ticketing-page/ticketing-page.component";
import {PageInvoicesListComponent} from "~features/customer-overview/pages/ticketing-page/page-invoices-list/page-invoices-list.component";
import {PageCancellationsListComponent} from "~features/customer-overview/pages/ticketing-page/page-cancellations-list/page-cancellations-list.component";
import {PageReservationsListComponent} from "~features/customer-overview/pages/ticketing-page/page-reservations-list/page-reservations-list.component";
import {ReminderEditComponent} from "~features/customer-overview/components/forms/reminder-edit/reminder-edit.component";
import {HomeReminderEditComponent} from "~features/customer-overview/components/forms/home-reminder-edit/home-reminder-edit.component";
import {ReminderComponent} from "~features/customer-overview/components/forms/reminder/reminder.component";
import {ReminderListComponent} from "~features/customer-overview/components/info-tiles/reminder-list/reminder-list.component";
import {ReminderPageComponent} from "~features/customer-overview/pages/reminder-page/reminder-page.component";
import {SepaMandatesPageComponent} from "~features/customer-overview/pages/sepa-mandates-page/sepa-mandates-page.component";
import {TixxSelectListComponent} from "~features/customer-overview/components/info-tiles/tixx-select-list/tixx-select-list.component";
import {TixxSelectPageComponent} from "~features/customer-overview/pages/tixx-select-page/tixx-select-page.component";
import {CampaiMembershipEditComponent} from "~features/customer-overview/components/forms/membership/campai-membership-edit/campai-membership-edit.component";

/**
 * Module for customer overview section
 */
@NgModule({
  declarations: [
    ActivityHistoryComponent,
    AttributesComponent,
    BankDataComponent,
    BankDataEditComponent,
    BankDataListComponent,
    ContactManagementComponent,
    ContactManagementEditComponent,
    ContactManagementListComponent,
    ContactManagementPageComponent,
    AddressComponent,
    AddressEditComponent,
    AddressListComponent,
    CustomerInvoicesListComponent,
    MerchandisingListComponent,
    CampaignActivityComponent,
    CrmMembershipComponent,
    CrmMembershipEditComponent,
    CrmMembershipListComponent,
    CampaiMembershipListComponent,
    CustomerOverviewComponent,
    MerchandisingPageComponent,
    CampaignActivityPageComponent,
    CustomerDataComponent,
    CustomerDataInfoComponent,
    CommunicationDataComponent,
    CommunicationDataInfoComponent,
    AttributesInfoComponent,
    CustomerInvoicesComponent,
    CustomerReservationsListComponent,
    CustomerCancellationsListComponent,
    TicketingComponent,
    TicketingPageComponent,
    PageInvoicesListComponent,
    PageCancellationsListComponent,
    PageReservationsListComponent,
    CustomerAccessEmailComponent,
    CustomerDuplicateMessageComponent,
    ReminderEditComponent,
    HomeReminderEditComponent,
    ReminderComponent,
    ReminderListComponent,
    ReminderPageComponent,
    SepaMandatesPageComponent,
    TixxSelectListComponent,
    TixxSelectPageComponent,
    CampaiMembershipEditComponent
  ],
  exports: [
    ActivityHistoryComponent,
    AttributesComponent,
    BankDataComponent,
    BankDataEditComponent,
    BankDataListComponent,
    ContactManagementComponent,
    ContactManagementEditComponent,
    ContactManagementListComponent,
    ContactManagementPageComponent,
    AddressComponent,
    AddressEditComponent,
    AddressListComponent,
    CustomerInvoicesListComponent,
    MerchandisingListComponent,
    CampaignActivityComponent,
    CrmMembershipComponent,
    CrmMembershipEditComponent,
    CrmMembershipListComponent,
    CampaiMembershipListComponent,
    CustomerOverviewComponent,
    MerchandisingPageComponent,
    CampaignActivityPageComponent,
    CustomerDataComponent,
    CustomerDataInfoComponent,
    CommunicationDataComponent,
    CommunicationDataInfoComponent,
    AttributesInfoComponent,
    CustomerInvoicesComponent,
    CustomerReservationsListComponent,
    CustomerCancellationsListComponent,
    TicketingComponent,
    TicketingPageComponent,
    PageInvoicesListComponent,
    PageCancellationsListComponent,
    PageReservationsListComponent,
    CustomerAccessEmailComponent,
    CustomerDuplicateMessageComponent,
    ReminderEditComponent,
    HomeReminderEditComponent,
    ReminderComponent,
    ReminderListComponent,
    ReminderPageComponent,
    SepaMandatesPageComponent,
    TixxSelectListComponent,
    TixxSelectPageComponent,
    CampaiMembershipEditComponent
  ],
  providers: [
    CustomerOverViewService,
    DatePipe,
    TitleCasePipe
  ],
  imports: [
    CommonModule,
    routing,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    DirectivesModule,
    FormValidationModule,
    FormFieldsModule,
    ButtonsModule,
    TablesModule,
    WorkspaceFormModule,
    TooltipModule,
    ModalModule,
  ]
})
export class CustomerOverviewModule {
}
